module.exports = __webpack_public_path__ + "img/shibcoin-bg.2abae518.png";